/** 申请发票相关接口 */
import request from '@/utils/util.request';

/*
 *  (invoice) 申请发票，加载初始数据
 *  @param {int} wx_payment_id:
 */
export const invoice_load_data = (data) => {
	return request({
		url: '/invoice/loaddata',
		data,
	});
};

/*
 *  (invoice) 申请发票，提交
 *  @param {int} wx_payment_id: 来自加载
 *  @param {int} amount: 金额（分）
 *  @param {string} title: 抬头
 *  @param {string} tax_no: 税号
 *  @param {int} type: 类型（2）
 *  @param {string} email: 邮箱
 *  @param {string | null} address: 地址电话
 *  @param {string | null} bank: 银行账号
 *  @param {int} mergeable: 发票是否可以合并
 */
export const invoice_submit = (data) => {
	return request({
		url: '/invoice/submit',
		data,
	});
};
